<template lang="pug">
  div.box
    div.box-header.b-b
      h3 Types
      small Filter by payment types
    div.box-body
      div.checkbox-list
        div.checkbox(v-for="t in typeList")
          label.ui-check
            input(type="checkbox" :value="t.type" v-model="filterTypes")
            i.dark-white
            | {{ t.name }}
</template>

<script>
import paymentTypes from './payment-types';

export default {
    data() {
        return {
            typeList: paymentTypes,
        };
    },
    computed: {
        filterTypes: {
            get() {
                return this.$store.getters['payment/filterTypes'];
            },

            set(value) {
                this.$store.commit('payment/setFilterTypes', value);
            },
        },
    },
};
</script>

<style lang="scss">
.checkbox-list {
    .checkbox:last-child {
        margin-bottom: 0;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/payment/settings-payment-type-filter.vue